import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import type { createAvailabilitySchema } from "backend/src/schemas/AvailabilitySchema";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
// import { UserType } from "../query/useCurrentUserQuery";

type OrgAddMemberResponseType = ResponseType<{
  userAvailabilityId: string,
      userId: string,
      reason: string,
      startDate: Date,
      endDate: Date | null,
      createdAt: Date,
      updatedAt: Date
}>;

function useAddAvailabilityMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<OrgAddMemberResponseType>["response"],
    AxiosResponseAndError<OrgAddMemberResponseType>["error"],
    z.infer<typeof createAvailabilitySchema>
  >({
    mutationFn: (data) =>
      ApiRequest.post<OrgAddMemberResponseType>(`${requestURLs.availability}`, data),
  });

  return mutation;
}

export default useAddAvailabilityMutation;